import { render, staticRenderFns } from "./production-calendar.vue?vue&type=template&id=04f4fcc4&scoped=true&"
import script from "./production-calendar.vue?vue&type=script&lang=js&"
export * from "./production-calendar.vue?vue&type=script&lang=js&"
import style0 from "./production-calendar.vue?vue&type=style&index=0&id=04f4fcc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f4fcc4",
  null
  
)

export default component.exports